export function getCookie (cookieName) {
  const name = `${cookieName}=`
  const cookies = document.cookie.split(';')

  for (const cookie of cookies) {
    const trimmedCookie = cookie.trim()
    if (trimmedCookie.startsWith(name)) {
      return trimmedCookie.substring(name.length)
    }
  }
  return ''
}
